import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_GET_PORTFOLIO_FLEX_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_GET_PORTFOLIO_FLEX_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_GET_PORTFOLIO_FLEX_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/users/${id}/portfolio-flexs`,
    method: 'GET',
  })
);

export default apiCall;
